var endpointMap = {
	ar: {
		common: "translation-ar.json",
		"pages.billingAddressInformationForm": "translation-ar.json",
		"pages.buyerCriteria": "translation-ar.json",
		"pages.checkout": "translation-ar.json",
		"pages.commonFormStrings": "translation-ar.json",
		"pages.homepage": "translation-ar.json",
		"pages.intakeForm": "translation-ar.json",
		"pages.lowercarbonfuels": "translation-ar.json",
		"pages.myAccount": "translation-ar.json",
		"pages.productdetails": "translation-ar.json",
		"pages.reducedeforestation": "translation-ar.json",
		"pages.restoringforests": "translation-ar.json",
		"pages.segmentpage": "translation-ar.json",
		"pages.storepage": "translation-ar.json",
		"pages.superpollutants": "translation-ar.json",
		"pages.techcarbonremoval": "translation-ar.json"
	},
	"ar-AE": {
		common: "translation-ar.json",
		"pages.billingAddressInformationForm": "translation-ar.json",
		"pages.buyerCriteria": "translation-ar.json",
		"pages.checkout": "translation-ar.json",
		"pages.commonFormStrings": "translation-ar.json",
		"pages.homepage": "translation-ar.json",
		"pages.intakeForm": "translation-ar.json",
		"pages.lowercarbonfuels": "translation-ar.json",
		"pages.myAccount": "translation-ar.json",
		"pages.productdetails": "translation-ar.json",
		"pages.reducedeforestation": "translation-ar.json",
		"pages.restoringforests": "translation-ar.json",
		"pages.segmentpage": "translation-ar.json",
		"pages.storepage": "translation-ar.json",
		"pages.superpollutants": "translation-ar.json",
		"pages.techcarbonremoval": "translation-ar.json"
	},
	bn: {
		common: "translation-bn.json",
		"pages.billingAddressInformationForm": "translation-bn.json",
		"pages.buyerCriteria": "translation-bn.json",
		"pages.checkout": "translation-bn.json",
		"pages.commonFormStrings": "translation-bn.json",
		"pages.homepage": "translation-bn.json",
		"pages.intakeForm": "translation-bn.json",
		"pages.lowercarbonfuels": "translation-bn.json",
		"pages.myAccount": "translation-bn.json",
		"pages.productdetails": "translation-bn.json",
		"pages.reducedeforestation": "translation-bn.json",
		"pages.restoringforests": "translation-bn.json",
		"pages.segmentpage": "translation-bn.json",
		"pages.storepage": "translation-bn.json",
		"pages.superpollutants": "translation-bn.json",
		"pages.techcarbonremoval": "translation-bn.json"
	},
	"bn-IN": {
		common: "translation-bn.json",
		"pages.billingAddressInformationForm": "translation-bn.json",
		"pages.buyerCriteria": "translation-bn.json",
		"pages.checkout": "translation-bn.json",
		"pages.commonFormStrings": "translation-bn.json",
		"pages.homepage": "translation-bn.json",
		"pages.intakeForm": "translation-bn.json",
		"pages.lowercarbonfuels": "translation-bn.json",
		"pages.myAccount": "translation-bn.json",
		"pages.productdetails": "translation-bn.json",
		"pages.reducedeforestation": "translation-bn.json",
		"pages.restoringforests": "translation-bn.json",
		"pages.segmentpage": "translation-bn.json",
		"pages.storepage": "translation-bn.json",
		"pages.superpollutants": "translation-bn.json",
		"pages.techcarbonremoval": "translation-bn.json"
	},
	cs: {
		common: "translation-cs.json",
		"pages.billingAddressInformationForm": "translation-cs.json",
		"pages.buyerCriteria": "translation-cs.json",
		"pages.checkout": "translation-cs.json",
		"pages.commonFormStrings": "translation-cs.json",
		"pages.homepage": "translation-cs.json",
		"pages.intakeForm": "translation-cs.json",
		"pages.lowercarbonfuels": "translation-cs.json",
		"pages.myAccount": "translation-cs.json",
		"pages.productdetails": "translation-cs.json",
		"pages.reducedeforestation": "translation-cs.json",
		"pages.restoringforests": "translation-cs.json",
		"pages.segmentpage": "translation-cs.json",
		"pages.storepage": "translation-cs.json",
		"pages.superpollutants": "translation-cs.json",
		"pages.techcarbonremoval": "translation-cs.json"
	},
	"cs-CZ": {
		common: "translation-cs.json",
		"pages.billingAddressInformationForm": "translation-cs.json",
		"pages.buyerCriteria": "translation-cs.json",
		"pages.checkout": "translation-cs.json",
		"pages.commonFormStrings": "translation-cs.json",
		"pages.homepage": "translation-cs.json",
		"pages.intakeForm": "translation-cs.json",
		"pages.lowercarbonfuels": "translation-cs.json",
		"pages.myAccount": "translation-cs.json",
		"pages.productdetails": "translation-cs.json",
		"pages.reducedeforestation": "translation-cs.json",
		"pages.restoringforests": "translation-cs.json",
		"pages.segmentpage": "translation-cs.json",
		"pages.storepage": "translation-cs.json",
		"pages.superpollutants": "translation-cs.json",
		"pages.techcarbonremoval": "translation-cs.json"
	},
	de: {
		common: "translation-de.json",
		"pages.billingAddressInformationForm": "translation-de.json",
		"pages.buyerCriteria": "translation-de.json",
		"pages.checkout": "translation-de.json",
		"pages.commonFormStrings": "translation-de.json",
		"pages.homepage": "translation-de.json",
		"pages.intakeForm": "translation-de.json",
		"pages.lowercarbonfuels": "translation-de.json",
		"pages.myAccount": "translation-de.json",
		"pages.productdetails": "translation-de.json",
		"pages.reducedeforestation": "translation-de.json",
		"pages.restoringforests": "translation-de.json",
		"pages.segmentpage": "translation-de.json",
		"pages.storepage": "translation-de.json",
		"pages.superpollutants": "translation-de.json",
		"pages.techcarbonremoval": "translation-de.json"
	},
	"de-DE": {
		common: "translation-de.json",
		"pages.billingAddressInformationForm": "translation-de.json",
		"pages.buyerCriteria": "translation-de.json",
		"pages.checkout": "translation-de.json",
		"pages.commonFormStrings": "translation-de.json",
		"pages.homepage": "translation-de.json",
		"pages.intakeForm": "translation-de.json",
		"pages.lowercarbonfuels": "translation-de.json",
		"pages.myAccount": "translation-de.json",
		"pages.productdetails": "translation-de.json",
		"pages.reducedeforestation": "translation-de.json",
		"pages.restoringforests": "translation-de.json",
		"pages.segmentpage": "translation-de.json",
		"pages.storepage": "translation-de.json",
		"pages.superpollutants": "translation-de.json",
		"pages.techcarbonremoval": "translation-de.json"
	},
	en: {
		common: "translation-en.json",
		"pages.billingAddressInformationForm": "translation-en.json",
		"pages.buyerCriteria": "translation-en.json",
		"pages.checkout": "translation-en.json",
		"pages.commonFormStrings": "translation-en.json",
		"pages.homepage": "translation-en.json",
		"pages.intakeForm": "translation-en.json",
		"pages.lowercarbonfuels": "translation-en.json",
		"pages.myAccount": "translation-en.json",
		"pages.productdetails": "translation-en.json",
		"pages.reducedeforestation": "translation-en.json",
		"pages.restoringforests": "translation-en.json",
		"pages.segmentpage": "translation-en.json",
		"pages.storepage": "translation-en.json",
		"pages.superpollutants": "translation-en.json",
		"pages.techcarbonremoval": "translation-en.json"
	},
	"en-US": {
		common: "translation-en.json",
		"pages.billingAddressInformationForm": "translation-en.json",
		"pages.buyerCriteria": "translation-en.json",
		"pages.checkout": "translation-en.json",
		"pages.commonFormStrings": "translation-en.json",
		"pages.homepage": "translation-en.json",
		"pages.intakeForm": "translation-en.json",
		"pages.lowercarbonfuels": "translation-en.json",
		"pages.myAccount": "translation-en.json",
		"pages.productdetails": "translation-en.json",
		"pages.reducedeforestation": "translation-en.json",
		"pages.restoringforests": "translation-en.json",
		"pages.segmentpage": "translation-en.json",
		"pages.storepage": "translation-en.json",
		"pages.superpollutants": "translation-en.json",
		"pages.techcarbonremoval": "translation-en.json"
	},
	es: {
		common: "translation-es.json",
		"pages.billingAddressInformationForm": "translation-es.json",
		"pages.buyerCriteria": "translation-es.json",
		"pages.checkout": "translation-es.json",
		"pages.commonFormStrings": "translation-es.json",
		"pages.homepage": "translation-es.json",
		"pages.intakeForm": "translation-es.json",
		"pages.lowercarbonfuels": "translation-es.json",
		"pages.myAccount": "translation-es.json",
		"pages.productdetails": "translation-es.json",
		"pages.reducedeforestation": "translation-es.json",
		"pages.restoringforests": "translation-es.json",
		"pages.segmentpage": "translation-es.json",
		"pages.storepage": "translation-es.json",
		"pages.superpollutants": "translation-es.json",
		"pages.techcarbonremoval": "translation-es.json"
	},
	"es-ES": {
		common: "translation-es.json",
		"pages.billingAddressInformationForm": "translation-es.json",
		"pages.buyerCriteria": "translation-es.json",
		"pages.checkout": "translation-es.json",
		"pages.commonFormStrings": "translation-es.json",
		"pages.homepage": "translation-es.json",
		"pages.intakeForm": "translation-es.json",
		"pages.lowercarbonfuels": "translation-es.json",
		"pages.myAccount": "translation-es.json",
		"pages.productdetails": "translation-es.json",
		"pages.reducedeforestation": "translation-es.json",
		"pages.restoringforests": "translation-es.json",
		"pages.segmentpage": "translation-es.json",
		"pages.storepage": "translation-es.json",
		"pages.superpollutants": "translation-es.json",
		"pages.techcarbonremoval": "translation-es.json"
	},
	"es-MX": {
		common: "translation-es.json",
		"pages.billingAddressInformationForm": "translation-es.json",
		"pages.buyerCriteria": "translation-es.json",
		"pages.checkout": "translation-es.json",
		"pages.commonFormStrings": "translation-es.json",
		"pages.homepage": "translation-es.json",
		"pages.intakeForm": "translation-es.json",
		"pages.lowercarbonfuels": "translation-es.json",
		"pages.myAccount": "translation-es.json",
		"pages.productdetails": "translation-es.json",
		"pages.reducedeforestation": "translation-es.json",
		"pages.restoringforests": "translation-es.json",
		"pages.segmentpage": "translation-es.json",
		"pages.storepage": "translation-es.json",
		"pages.superpollutants": "translation-es.json",
		"pages.techcarbonremoval": "translation-es.json"
	},
	"es-US": {
		common: "translation-es.json",
		"pages.billingAddressInformationForm": "translation-es.json",
		"pages.buyerCriteria": "translation-es.json",
		"pages.checkout": "translation-es.json",
		"pages.commonFormStrings": "translation-es.json",
		"pages.homepage": "translation-es.json",
		"pages.intakeForm": "translation-es.json",
		"pages.lowercarbonfuels": "translation-es.json",
		"pages.myAccount": "translation-es.json",
		"pages.productdetails": "translation-es.json",
		"pages.reducedeforestation": "translation-es.json",
		"pages.restoringforests": "translation-es.json",
		"pages.segmentpage": "translation-es.json",
		"pages.storepage": "translation-es.json",
		"pages.superpollutants": "translation-es.json",
		"pages.techcarbonremoval": "translation-es.json"
	},
	fr: {
		common: "translation-fr.json",
		"pages.billingAddressInformationForm": "translation-fr.json",
		"pages.buyerCriteria": "translation-fr.json",
		"pages.checkout": "translation-fr.json",
		"pages.commonFormStrings": "translation-fr.json",
		"pages.homepage": "translation-fr.json",
		"pages.intakeForm": "translation-fr.json",
		"pages.lowercarbonfuels": "translation-fr.json",
		"pages.myAccount": "translation-fr.json",
		"pages.productdetails": "translation-fr.json",
		"pages.reducedeforestation": "translation-fr.json",
		"pages.restoringforests": "translation-fr.json",
		"pages.segmentpage": "translation-fr.json",
		"pages.storepage": "translation-fr.json",
		"pages.superpollutants": "translation-fr.json",
		"pages.techcarbonremoval": "translation-fr.json"
	},
	"fr-BE": {
		common: "translation-fr.json",
		"pages.billingAddressInformationForm": "translation-fr.json",
		"pages.buyerCriteria": "translation-fr.json",
		"pages.checkout": "translation-fr.json",
		"pages.commonFormStrings": "translation-fr.json",
		"pages.homepage": "translation-fr.json",
		"pages.intakeForm": "translation-fr.json",
		"pages.lowercarbonfuels": "translation-fr.json",
		"pages.myAccount": "translation-fr.json",
		"pages.productdetails": "translation-fr.json",
		"pages.reducedeforestation": "translation-fr.json",
		"pages.restoringforests": "translation-fr.json",
		"pages.segmentpage": "translation-fr.json",
		"pages.storepage": "translation-fr.json",
		"pages.superpollutants": "translation-fr.json",
		"pages.techcarbonremoval": "translation-fr.json"
	},
	"fr-CA": {
		common: "translation-fr.json",
		"pages.billingAddressInformationForm": "translation-fr.json",
		"pages.buyerCriteria": "translation-fr.json",
		"pages.checkout": "translation-fr.json",
		"pages.commonFormStrings": "translation-fr.json",
		"pages.homepage": "translation-fr.json",
		"pages.intakeForm": "translation-fr.json",
		"pages.lowercarbonfuels": "translation-fr.json",
		"pages.myAccount": "translation-fr.json",
		"pages.productdetails": "translation-fr.json",
		"pages.reducedeforestation": "translation-fr.json",
		"pages.restoringforests": "translation-fr.json",
		"pages.segmentpage": "translation-fr.json",
		"pages.storepage": "translation-fr.json",
		"pages.superpollutants": "translation-fr.json",
		"pages.techcarbonremoval": "translation-fr.json"
	},
	"fr-FR": {
		common: "translation-fr.json",
		"pages.billingAddressInformationForm": "translation-fr.json",
		"pages.buyerCriteria": "translation-fr.json",
		"pages.checkout": "translation-fr.json",
		"pages.commonFormStrings": "translation-fr.json",
		"pages.homepage": "translation-fr.json",
		"pages.intakeForm": "translation-fr.json",
		"pages.lowercarbonfuels": "translation-fr.json",
		"pages.myAccount": "translation-fr.json",
		"pages.productdetails": "translation-fr.json",
		"pages.reducedeforestation": "translation-fr.json",
		"pages.restoringforests": "translation-fr.json",
		"pages.segmentpage": "translation-fr.json",
		"pages.storepage": "translation-fr.json",
		"pages.superpollutants": "translation-fr.json",
		"pages.techcarbonremoval": "translation-fr.json"
	},
	hi: {
		common: "translation-hi.json",
		"pages.billingAddressInformationForm": "translation-hi.json",
		"pages.buyerCriteria": "translation-hi.json",
		"pages.checkout": "translation-hi.json",
		"pages.commonFormStrings": "translation-hi.json",
		"pages.homepage": "translation-hi.json",
		"pages.intakeForm": "translation-hi.json",
		"pages.lowercarbonfuels": "translation-hi.json",
		"pages.myAccount": "translation-hi.json",
		"pages.productdetails": "translation-hi.json",
		"pages.reducedeforestation": "translation-hi.json",
		"pages.restoringforests": "translation-hi.json",
		"pages.segmentpage": "translation-hi.json",
		"pages.storepage": "translation-hi.json",
		"pages.superpollutants": "translation-hi.json",
		"pages.techcarbonremoval": "translation-hi.json"
	},
	"hi-IN": {
		common: "translation-hi.json",
		"pages.billingAddressInformationForm": "translation-hi.json",
		"pages.buyerCriteria": "translation-hi.json",
		"pages.checkout": "translation-hi.json",
		"pages.commonFormStrings": "translation-hi.json",
		"pages.homepage": "translation-hi.json",
		"pages.intakeForm": "translation-hi.json",
		"pages.lowercarbonfuels": "translation-hi.json",
		"pages.myAccount": "translation-hi.json",
		"pages.productdetails": "translation-hi.json",
		"pages.reducedeforestation": "translation-hi.json",
		"pages.restoringforests": "translation-hi.json",
		"pages.segmentpage": "translation-hi.json",
		"pages.storepage": "translation-hi.json",
		"pages.superpollutants": "translation-hi.json",
		"pages.techcarbonremoval": "translation-hi.json"
	},
	it: {
		common: "translation-it.json",
		"pages.billingAddressInformationForm": "translation-it.json",
		"pages.buyerCriteria": "translation-it.json",
		"pages.checkout": "translation-it.json",
		"pages.commonFormStrings": "translation-it.json",
		"pages.homepage": "translation-it.json",
		"pages.intakeForm": "translation-it.json",
		"pages.lowercarbonfuels": "translation-it.json",
		"pages.myAccount": "translation-it.json",
		"pages.productdetails": "translation-it.json",
		"pages.reducedeforestation": "translation-it.json",
		"pages.restoringforests": "translation-it.json",
		"pages.segmentpage": "translation-it.json",
		"pages.storepage": "translation-it.json",
		"pages.superpollutants": "translation-it.json",
		"pages.techcarbonremoval": "translation-it.json"
	},
	"it-IT": {
		common: "translation-it.json",
		"pages.billingAddressInformationForm": "translation-it.json",
		"pages.buyerCriteria": "translation-it.json",
		"pages.checkout": "translation-it.json",
		"pages.commonFormStrings": "translation-it.json",
		"pages.homepage": "translation-it.json",
		"pages.intakeForm": "translation-it.json",
		"pages.lowercarbonfuels": "translation-it.json",
		"pages.myAccount": "translation-it.json",
		"pages.productdetails": "translation-it.json",
		"pages.reducedeforestation": "translation-it.json",
		"pages.restoringforests": "translation-it.json",
		"pages.segmentpage": "translation-it.json",
		"pages.storepage": "translation-it.json",
		"pages.superpollutants": "translation-it.json",
		"pages.techcarbonremoval": "translation-it.json"
	},
	ja: {
		common: "translation-ja.json",
		"pages.billingAddressInformationForm": "translation-ja.json",
		"pages.buyerCriteria": "translation-ja.json",
		"pages.checkout": "translation-ja.json",
		"pages.commonFormStrings": "translation-ja.json",
		"pages.homepage": "translation-ja.json",
		"pages.intakeForm": "translation-ja.json",
		"pages.lowercarbonfuels": "translation-ja.json",
		"pages.myAccount": "translation-ja.json",
		"pages.productdetails": "translation-ja.json",
		"pages.reducedeforestation": "translation-ja.json",
		"pages.restoringforests": "translation-ja.json",
		"pages.segmentpage": "translation-ja.json",
		"pages.storepage": "translation-ja.json",
		"pages.superpollutants": "translation-ja.json",
		"pages.techcarbonremoval": "translation-ja.json"
	},
	"ja-JP": {
		common: "translation-ja.json",
		"pages.billingAddressInformationForm": "translation-ja.json",
		"pages.buyerCriteria": "translation-ja.json",
		"pages.checkout": "translation-ja.json",
		"pages.commonFormStrings": "translation-ja.json",
		"pages.homepage": "translation-ja.json",
		"pages.intakeForm": "translation-ja.json",
		"pages.lowercarbonfuels": "translation-ja.json",
		"pages.myAccount": "translation-ja.json",
		"pages.productdetails": "translation-ja.json",
		"pages.reducedeforestation": "translation-ja.json",
		"pages.restoringforests": "translation-ja.json",
		"pages.segmentpage": "translation-ja.json",
		"pages.storepage": "translation-ja.json",
		"pages.superpollutants": "translation-ja.json",
		"pages.techcarbonremoval": "translation-ja.json"
	},
	km: {
		common: "translation-km.json",
		"pages.billingAddressInformationForm": "translation-km.json",
		"pages.buyerCriteria": "translation-km.json",
		"pages.checkout": "translation-km.json",
		"pages.commonFormStrings": "translation-km.json",
		"pages.homepage": "translation-km.json",
		"pages.intakeForm": "translation-km.json",
		"pages.lowercarbonfuels": "translation-km.json",
		"pages.myAccount": "translation-km.json",
		"pages.productdetails": "translation-km.json",
		"pages.reducedeforestation": "translation-km.json",
		"pages.restoringforests": "translation-km.json",
		"pages.segmentpage": "translation-km.json",
		"pages.storepage": "translation-km.json",
		"pages.superpollutants": "translation-km.json",
		"pages.techcarbonremoval": "translation-km.json"
	},
	"km-KH": {
		common: "translation-km.json",
		"pages.billingAddressInformationForm": "translation-km.json",
		"pages.buyerCriteria": "translation-km.json",
		"pages.checkout": "translation-km.json",
		"pages.commonFormStrings": "translation-km.json",
		"pages.homepage": "translation-km.json",
		"pages.intakeForm": "translation-km.json",
		"pages.lowercarbonfuels": "translation-km.json",
		"pages.myAccount": "translation-km.json",
		"pages.productdetails": "translation-km.json",
		"pages.reducedeforestation": "translation-km.json",
		"pages.restoringforests": "translation-km.json",
		"pages.segmentpage": "translation-km.json",
		"pages.storepage": "translation-km.json",
		"pages.superpollutants": "translation-km.json",
		"pages.techcarbonremoval": "translation-km.json"
	},
	kn: {
		common: "translation-kn.json",
		"pages.billingAddressInformationForm": "translation-kn.json",
		"pages.buyerCriteria": "translation-kn.json",
		"pages.checkout": "translation-kn.json",
		"pages.commonFormStrings": "translation-kn.json",
		"pages.homepage": "translation-kn.json",
		"pages.intakeForm": "translation-kn.json",
		"pages.lowercarbonfuels": "translation-kn.json",
		"pages.myAccount": "translation-kn.json",
		"pages.productdetails": "translation-kn.json",
		"pages.reducedeforestation": "translation-kn.json",
		"pages.restoringforests": "translation-kn.json",
		"pages.segmentpage": "translation-kn.json",
		"pages.storepage": "translation-kn.json",
		"pages.superpollutants": "translation-kn.json",
		"pages.techcarbonremoval": "translation-kn.json"
	},
	"kn-IN": {
		common: "translation-kn.json",
		"pages.billingAddressInformationForm": "translation-kn.json",
		"pages.buyerCriteria": "translation-kn.json",
		"pages.checkout": "translation-kn.json",
		"pages.commonFormStrings": "translation-kn.json",
		"pages.homepage": "translation-kn.json",
		"pages.intakeForm": "translation-kn.json",
		"pages.lowercarbonfuels": "translation-kn.json",
		"pages.myAccount": "translation-kn.json",
		"pages.productdetails": "translation-kn.json",
		"pages.reducedeforestation": "translation-kn.json",
		"pages.restoringforests": "translation-kn.json",
		"pages.segmentpage": "translation-kn.json",
		"pages.storepage": "translation-kn.json",
		"pages.superpollutants": "translation-kn.json",
		"pages.techcarbonremoval": "translation-kn.json"
	},
	mr: {
		common: "translation-mr.json",
		"pages.billingAddressInformationForm": "translation-mr.json",
		"pages.buyerCriteria": "translation-mr.json",
		"pages.checkout": "translation-mr.json",
		"pages.commonFormStrings": "translation-mr.json",
		"pages.homepage": "translation-mr.json",
		"pages.intakeForm": "translation-mr.json",
		"pages.lowercarbonfuels": "translation-mr.json",
		"pages.myAccount": "translation-mr.json",
		"pages.productdetails": "translation-mr.json",
		"pages.reducedeforestation": "translation-mr.json",
		"pages.restoringforests": "translation-mr.json",
		"pages.segmentpage": "translation-mr.json",
		"pages.storepage": "translation-mr.json",
		"pages.superpollutants": "translation-mr.json",
		"pages.techcarbonremoval": "translation-mr.json"
	},
	"mr-IN": {
		common: "translation-mr.json",
		"pages.billingAddressInformationForm": "translation-mr.json",
		"pages.buyerCriteria": "translation-mr.json",
		"pages.checkout": "translation-mr.json",
		"pages.commonFormStrings": "translation-mr.json",
		"pages.homepage": "translation-mr.json",
		"pages.intakeForm": "translation-mr.json",
		"pages.lowercarbonfuels": "translation-mr.json",
		"pages.myAccount": "translation-mr.json",
		"pages.productdetails": "translation-mr.json",
		"pages.reducedeforestation": "translation-mr.json",
		"pages.restoringforests": "translation-mr.json",
		"pages.segmentpage": "translation-mr.json",
		"pages.storepage": "translation-mr.json",
		"pages.superpollutants": "translation-mr.json",
		"pages.techcarbonremoval": "translation-mr.json"
	},
	pl: {
		common: "translation-pl.json",
		"pages.billingAddressInformationForm": "translation-pl.json",
		"pages.buyerCriteria": "translation-pl.json",
		"pages.checkout": "translation-pl.json",
		"pages.commonFormStrings": "translation-pl.json",
		"pages.homepage": "translation-pl.json",
		"pages.intakeForm": "translation-pl.json",
		"pages.lowercarbonfuels": "translation-pl.json",
		"pages.myAccount": "translation-pl.json",
		"pages.productdetails": "translation-pl.json",
		"pages.reducedeforestation": "translation-pl.json",
		"pages.restoringforests": "translation-pl.json",
		"pages.segmentpage": "translation-pl.json",
		"pages.storepage": "translation-pl.json",
		"pages.superpollutants": "translation-pl.json",
		"pages.techcarbonremoval": "translation-pl.json"
	},
	"pl-PL": {
		common: "translation-pl.json",
		"pages.billingAddressInformationForm": "translation-pl.json",
		"pages.buyerCriteria": "translation-pl.json",
		"pages.checkout": "translation-pl.json",
		"pages.commonFormStrings": "translation-pl.json",
		"pages.homepage": "translation-pl.json",
		"pages.intakeForm": "translation-pl.json",
		"pages.lowercarbonfuels": "translation-pl.json",
		"pages.myAccount": "translation-pl.json",
		"pages.productdetails": "translation-pl.json",
		"pages.reducedeforestation": "translation-pl.json",
		"pages.restoringforests": "translation-pl.json",
		"pages.segmentpage": "translation-pl.json",
		"pages.storepage": "translation-pl.json",
		"pages.superpollutants": "translation-pl.json",
		"pages.techcarbonremoval": "translation-pl.json"
	},
	pt: {
		common: "translation-pt.json",
		"pages.billingAddressInformationForm": "translation-pt.json",
		"pages.buyerCriteria": "translation-pt.json",
		"pages.checkout": "translation-pt.json",
		"pages.commonFormStrings": "translation-pt.json",
		"pages.homepage": "translation-pt.json",
		"pages.intakeForm": "translation-pt.json",
		"pages.lowercarbonfuels": "translation-pt.json",
		"pages.myAccount": "translation-pt.json",
		"pages.productdetails": "translation-pt.json",
		"pages.reducedeforestation": "translation-pt.json",
		"pages.restoringforests": "translation-pt.json",
		"pages.segmentpage": "translation-pt.json",
		"pages.storepage": "translation-pt.json",
		"pages.superpollutants": "translation-pt.json",
		"pages.techcarbonremoval": "translation-pt.json"
	},
	"pt-BR": {
		common: "translation-pt.json",
		"pages.billingAddressInformationForm": "translation-pt.json",
		"pages.buyerCriteria": "translation-pt.json",
		"pages.checkout": "translation-pt.json",
		"pages.commonFormStrings": "translation-pt.json",
		"pages.homepage": "translation-pt.json",
		"pages.intakeForm": "translation-pt.json",
		"pages.lowercarbonfuels": "translation-pt.json",
		"pages.myAccount": "translation-pt.json",
		"pages.productdetails": "translation-pt.json",
		"pages.reducedeforestation": "translation-pt.json",
		"pages.restoringforests": "translation-pt.json",
		"pages.segmentpage": "translation-pt.json",
		"pages.storepage": "translation-pt.json",
		"pages.superpollutants": "translation-pt.json",
		"pages.techcarbonremoval": "translation-pt.json"
	},
	"pt-PT": {
		common: "translation-pt.json",
		"pages.billingAddressInformationForm": "translation-pt.json",
		"pages.buyerCriteria": "translation-pt.json",
		"pages.checkout": "translation-pt.json",
		"pages.commonFormStrings": "translation-pt.json",
		"pages.homepage": "translation-pt.json",
		"pages.intakeForm": "translation-pt.json",
		"pages.lowercarbonfuels": "translation-pt.json",
		"pages.myAccount": "translation-pt.json",
		"pages.productdetails": "translation-pt.json",
		"pages.reducedeforestation": "translation-pt.json",
		"pages.restoringforests": "translation-pt.json",
		"pages.segmentpage": "translation-pt.json",
		"pages.storepage": "translation-pt.json",
		"pages.superpollutants": "translation-pt.json",
		"pages.techcarbonremoval": "translation-pt.json"
	},
	si: {
		common: "translation-si.json",
		"pages.billingAddressInformationForm": "translation-si.json",
		"pages.buyerCriteria": "translation-si.json",
		"pages.checkout": "translation-si.json",
		"pages.commonFormStrings": "translation-si.json",
		"pages.homepage": "translation-si.json",
		"pages.intakeForm": "translation-si.json",
		"pages.lowercarbonfuels": "translation-si.json",
		"pages.myAccount": "translation-si.json",
		"pages.productdetails": "translation-si.json",
		"pages.reducedeforestation": "translation-si.json",
		"pages.restoringforests": "translation-si.json",
		"pages.segmentpage": "translation-si.json",
		"pages.storepage": "translation-si.json",
		"pages.superpollutants": "translation-si.json",
		"pages.techcarbonremoval": "translation-si.json"
	},
	"si-LK": {
		common: "translation-si.json",
		"pages.billingAddressInformationForm": "translation-si.json",
		"pages.buyerCriteria": "translation-si.json",
		"pages.checkout": "translation-si.json",
		"pages.commonFormStrings": "translation-si.json",
		"pages.homepage": "translation-si.json",
		"pages.intakeForm": "translation-si.json",
		"pages.lowercarbonfuels": "translation-si.json",
		"pages.myAccount": "translation-si.json",
		"pages.productdetails": "translation-si.json",
		"pages.reducedeforestation": "translation-si.json",
		"pages.restoringforests": "translation-si.json",
		"pages.segmentpage": "translation-si.json",
		"pages.storepage": "translation-si.json",
		"pages.superpollutants": "translation-si.json",
		"pages.techcarbonremoval": "translation-si.json"
	},
	sk: {
		common: "translation-sk.json",
		"pages.billingAddressInformationForm": "translation-sk.json",
		"pages.buyerCriteria": "translation-sk.json",
		"pages.checkout": "translation-sk.json",
		"pages.commonFormStrings": "translation-sk.json",
		"pages.homepage": "translation-sk.json",
		"pages.intakeForm": "translation-sk.json",
		"pages.lowercarbonfuels": "translation-sk.json",
		"pages.myAccount": "translation-sk.json",
		"pages.productdetails": "translation-sk.json",
		"pages.reducedeforestation": "translation-sk.json",
		"pages.restoringforests": "translation-sk.json",
		"pages.segmentpage": "translation-sk.json",
		"pages.storepage": "translation-sk.json",
		"pages.superpollutants": "translation-sk.json",
		"pages.techcarbonremoval": "translation-sk.json"
	},
	"sk-SK": {
		common: "translation-sk.json",
		"pages.billingAddressInformationForm": "translation-sk.json",
		"pages.buyerCriteria": "translation-sk.json",
		"pages.checkout": "translation-sk.json",
		"pages.commonFormStrings": "translation-sk.json",
		"pages.homepage": "translation-sk.json",
		"pages.intakeForm": "translation-sk.json",
		"pages.lowercarbonfuels": "translation-sk.json",
		"pages.myAccount": "translation-sk.json",
		"pages.productdetails": "translation-sk.json",
		"pages.reducedeforestation": "translation-sk.json",
		"pages.restoringforests": "translation-sk.json",
		"pages.segmentpage": "translation-sk.json",
		"pages.storepage": "translation-sk.json",
		"pages.superpollutants": "translation-sk.json",
		"pages.techcarbonremoval": "translation-sk.json"
	},
	ta: {
		common: "translation-ta.json",
		"pages.billingAddressInformationForm": "translation-ta.json",
		"pages.buyerCriteria": "translation-ta.json",
		"pages.checkout": "translation-ta.json",
		"pages.commonFormStrings": "translation-ta.json",
		"pages.homepage": "translation-ta.json",
		"pages.intakeForm": "translation-ta.json",
		"pages.lowercarbonfuels": "translation-ta.json",
		"pages.myAccount": "translation-ta.json",
		"pages.productdetails": "translation-ta.json",
		"pages.reducedeforestation": "translation-ta.json",
		"pages.restoringforests": "translation-ta.json",
		"pages.segmentpage": "translation-ta.json",
		"pages.storepage": "translation-ta.json",
		"pages.superpollutants": "translation-ta.json",
		"pages.techcarbonremoval": "translation-ta.json"
	},
	"ta-IN": {
		common: "translation-ta.json",
		"pages.billingAddressInformationForm": "translation-ta.json",
		"pages.buyerCriteria": "translation-ta.json",
		"pages.checkout": "translation-ta.json",
		"pages.commonFormStrings": "translation-ta.json",
		"pages.homepage": "translation-ta.json",
		"pages.intakeForm": "translation-ta.json",
		"pages.lowercarbonfuels": "translation-ta.json",
		"pages.myAccount": "translation-ta.json",
		"pages.productdetails": "translation-ta.json",
		"pages.reducedeforestation": "translation-ta.json",
		"pages.restoringforests": "translation-ta.json",
		"pages.segmentpage": "translation-ta.json",
		"pages.storepage": "translation-ta.json",
		"pages.superpollutants": "translation-ta.json",
		"pages.techcarbonremoval": "translation-ta.json"
	},
	te: {
		common: "translation-te.json",
		"pages.billingAddressInformationForm": "translation-te.json",
		"pages.buyerCriteria": "translation-te.json",
		"pages.checkout": "translation-te.json",
		"pages.commonFormStrings": "translation-te.json",
		"pages.homepage": "translation-te.json",
		"pages.intakeForm": "translation-te.json",
		"pages.lowercarbonfuels": "translation-te.json",
		"pages.myAccount": "translation-te.json",
		"pages.productdetails": "translation-te.json",
		"pages.reducedeforestation": "translation-te.json",
		"pages.restoringforests": "translation-te.json",
		"pages.segmentpage": "translation-te.json",
		"pages.storepage": "translation-te.json",
		"pages.superpollutants": "translation-te.json",
		"pages.techcarbonremoval": "translation-te.json"
	},
	"te-IN": {
		common: "translation-te.json",
		"pages.billingAddressInformationForm": "translation-te.json",
		"pages.buyerCriteria": "translation-te.json",
		"pages.checkout": "translation-te.json",
		"pages.commonFormStrings": "translation-te.json",
		"pages.homepage": "translation-te.json",
		"pages.intakeForm": "translation-te.json",
		"pages.lowercarbonfuels": "translation-te.json",
		"pages.myAccount": "translation-te.json",
		"pages.productdetails": "translation-te.json",
		"pages.reducedeforestation": "translation-te.json",
		"pages.restoringforests": "translation-te.json",
		"pages.segmentpage": "translation-te.json",
		"pages.storepage": "translation-te.json",
		"pages.superpollutants": "translation-te.json",
		"pages.techcarbonremoval": "translation-te.json"
	},
	tr: {
		common: "translation-tr.json",
		"pages.billingAddressInformationForm": "translation-tr.json",
		"pages.buyerCriteria": "translation-tr.json",
		"pages.checkout": "translation-tr.json",
		"pages.commonFormStrings": "translation-tr.json",
		"pages.homepage": "translation-tr.json",
		"pages.intakeForm": "translation-tr.json",
		"pages.lowercarbonfuels": "translation-tr.json",
		"pages.myAccount": "translation-tr.json",
		"pages.productdetails": "translation-tr.json",
		"pages.reducedeforestation": "translation-tr.json",
		"pages.restoringforests": "translation-tr.json",
		"pages.segmentpage": "translation-tr.json",
		"pages.storepage": "translation-tr.json",
		"pages.superpollutants": "translation-tr.json",
		"pages.techcarbonremoval": "translation-tr.json"
	},
	"tr-TR": {
		common: "translation-tr.json",
		"pages.billingAddressInformationForm": "translation-tr.json",
		"pages.buyerCriteria": "translation-tr.json",
		"pages.checkout": "translation-tr.json",
		"pages.commonFormStrings": "translation-tr.json",
		"pages.homepage": "translation-tr.json",
		"pages.intakeForm": "translation-tr.json",
		"pages.lowercarbonfuels": "translation-tr.json",
		"pages.myAccount": "translation-tr.json",
		"pages.productdetails": "translation-tr.json",
		"pages.reducedeforestation": "translation-tr.json",
		"pages.restoringforests": "translation-tr.json",
		"pages.segmentpage": "translation-tr.json",
		"pages.storepage": "translation-tr.json",
		"pages.superpollutants": "translation-tr.json",
		"pages.techcarbonremoval": "translation-tr.json"
	},
	und: {
		common: "translation.json",
		"pages.billingAddressInformationForm": "translation.json",
		"pages.buyerCriteria": "translation.json",
		"pages.checkout": "translation.json",
		"pages.commonFormStrings": "translation.json",
		"pages.homepage": "translation.json",
		"pages.intakeForm": "translation.json",
		"pages.lowercarbonfuels": "translation.json",
		"pages.myAccount": "translation.json",
		"pages.productdetails": "translation.json",
		"pages.reducedeforestation": "translation.json",
		"pages.restoringforests": "translation.json",
		"pages.segmentpage": "translation.json",
		"pages.storepage": "translation.json",
		"pages.superpollutants": "translation.json",
		"pages.techcarbonremoval": "translation.json"
	},
	vi: {
		common: "translation-vi.json",
		"pages.billingAddressInformationForm": "translation-vi.json",
		"pages.buyerCriteria": "translation-vi.json",
		"pages.checkout": "translation-vi.json",
		"pages.commonFormStrings": "translation-vi.json",
		"pages.homepage": "translation-vi.json",
		"pages.intakeForm": "translation-vi.json",
		"pages.lowercarbonfuels": "translation-vi.json",
		"pages.myAccount": "translation-vi.json",
		"pages.productdetails": "translation-vi.json",
		"pages.reducedeforestation": "translation-vi.json",
		"pages.restoringforests": "translation-vi.json",
		"pages.segmentpage": "translation-vi.json",
		"pages.storepage": "translation-vi.json",
		"pages.superpollutants": "translation-vi.json",
		"pages.techcarbonremoval": "translation-vi.json"
	},
	"vi-VN": {
		common: "translation-vi.json",
		"pages.billingAddressInformationForm": "translation-vi.json",
		"pages.buyerCriteria": "translation-vi.json",
		"pages.checkout": "translation-vi.json",
		"pages.commonFormStrings": "translation-vi.json",
		"pages.homepage": "translation-vi.json",
		"pages.intakeForm": "translation-vi.json",
		"pages.lowercarbonfuels": "translation-vi.json",
		"pages.myAccount": "translation-vi.json",
		"pages.productdetails": "translation-vi.json",
		"pages.reducedeforestation": "translation-vi.json",
		"pages.restoringforests": "translation-vi.json",
		"pages.segmentpage": "translation-vi.json",
		"pages.storepage": "translation-vi.json",
		"pages.superpollutants": "translation-vi.json",
		"pages.techcarbonremoval": "translation-vi.json"
	},
	zh: {
		common: "translation-zh.json",
		"pages.billingAddressInformationForm": "translation-zh.json",
		"pages.buyerCriteria": "translation-zh.json",
		"pages.checkout": "translation-zh.json",
		"pages.commonFormStrings": "translation-zh.json",
		"pages.homepage": "translation-zh.json",
		"pages.intakeForm": "translation-zh.json",
		"pages.lowercarbonfuels": "translation-zh.json",
		"pages.myAccount": "translation-zh.json",
		"pages.productdetails": "translation-zh.json",
		"pages.reducedeforestation": "translation-zh.json",
		"pages.restoringforests": "translation-zh.json",
		"pages.segmentpage": "translation-zh.json",
		"pages.storepage": "translation-zh.json",
		"pages.superpollutants": "translation-zh.json",
		"pages.techcarbonremoval": "translation-zh.json"
	},
	"zh-CN": {
		common: "translation-zh.json",
		"pages.billingAddressInformationForm": "translation-zh.json",
		"pages.buyerCriteria": "translation-zh.json",
		"pages.checkout": "translation-zh.json",
		"pages.commonFormStrings": "translation-zh.json",
		"pages.homepage": "translation-zh.json",
		"pages.intakeForm": "translation-zh.json",
		"pages.lowercarbonfuels": "translation-zh.json",
		"pages.myAccount": "translation-zh.json",
		"pages.productdetails": "translation-zh.json",
		"pages.reducedeforestation": "translation-zh.json",
		"pages.restoringforests": "translation-zh.json",
		"pages.segmentpage": "translation-zh.json",
		"pages.storepage": "translation-zh.json",
		"pages.superpollutants": "translation-zh.json",
		"pages.techcarbonremoval": "translation-zh.json"
	},
	"zh-TW": {
		common: "translation-zh.json",
		"pages.billingAddressInformationForm": "translation-zh.json",
		"pages.buyerCriteria": "translation-zh.json",
		"pages.checkout": "translation-zh.json",
		"pages.commonFormStrings": "translation-zh.json",
		"pages.homepage": "translation-zh.json",
		"pages.intakeForm": "translation-zh.json",
		"pages.lowercarbonfuels": "translation-zh.json",
		"pages.myAccount": "translation-zh.json",
		"pages.productdetails": "translation-zh.json",
		"pages.reducedeforestation": "translation-zh.json",
		"pages.restoringforests": "translation-zh.json",
		"pages.segmentpage": "translation-zh.json",
		"pages.storepage": "translation-zh.json",
		"pages.superpollutants": "translation-zh.json",
		"pages.techcarbonremoval": "translation-zh.json"
	}
};
var arbManifest = {
	endpointMap: endpointMap
};

export { arbManifest as default, endpointMap };
